// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rvun6IwUdm4XnEAhBdVZ{width:100%}.gpEAULQVYpglSr2WnX1E{margin-top:40px}.UFRtabO93SYWrvPE7KwW{margin-top:32px}.hfdu_1QBicBTPU5yrLVi{font-size:13px;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Rvun6IwUdm4XnEAhBdVZ`,
	"messageFlowField": `gpEAULQVYpglSr2WnX1E`,
	"optOutField": `UFRtabO93SYWrvPE7KwW`,
	"fieldText": `hfdu_1QBicBTPU5yrLVi`
};
export default ___CSS_LOADER_EXPORT___;
